import React from 'react'
import { shallow } from 'enzyme'
import moment from 'moment'

import SmartRateHistory from '../SmartRateHistory'

import loan from './testData/loan'
import SmartRateRow from '../SmartRateRow'

describe('<SmartRateHistory />', () => {
  let wrapper, props, instance
  beforeEach(() => {
    props = {
      predictionResults: loan.predictionResults
    }
    wrapper = shallow(<SmartRateHistory {...props} />)
    instance = wrapper.instance()
  })
  describe('#onShowToggle', () => {
    describe('when showAll is false', () => {
      beforeEach(() => {
        wrapper.setState({ showAll: false })
      })
      it('should change showAll to true', () => {
        instance.onShowToggle()
        expect(wrapper.state('showAll')).toBeTruthy()
      })
    })
    describe('when showAll is true', () => {
      beforeEach(() => {
        wrapper.setState({ showAll: true })
      })
      it('should change showAll to false', () => {
        instance.onShowToggle()
        expect(wrapper.state('showAll')).toBeFalsy()
      })
    })
  })
  describe('#renderPredictionResults', () => {
    describe('when showAll is false', () => {
      beforeEach(() => {
        wrapper.setState({ showAll: false })
      })
      it('should return a single <SmartRateRow />', () => {
        expect(wrapper.find(SmartRateRow)).toHaveLength(1)
      })
    })
    describe('when showAll is true', () => {
      beforeEach(() => {
        wrapper.setState({ showAll: true })
      })
      it('should return a <SmartRateRow /> for each prediction result', () => {
        expect(wrapper.find(SmartRateRow)).toHaveLength(loan.predictionResults.length)
      })
    })
  })
  describe('#render', () => {
    describe('when there are no predictionResults', () => {
      beforeEach(() => {
        wrapper.setProps({ predictionResults: [] })
      })
      it('should return null', () => {
        expect(instance.render()).toBeNull()
      })
    })
    describe('when there is at elast one predictionResult', () => {
      it('should return something', () => {
        expect(instance.render()).toBeTruthy()
      })
    })
  })
})
